import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import LeasePage from './LeasePage';
import SearchLeases from './SearchLeases';
import Permissions from 'src/models/Permissions';
import UserDetails from 'src/models/UserDetails';

export default function getRoutes(isLoggedIn: boolean, user: UserDetails) {
    return [
        <RoutePrivate
            key="leases"
            path="/leases"
            exact={true}
            component={SearchLeases}
            isLoggedIn={isLoggedIn}
            permissions={[Permissions.LeaseRecordsAccess]}
            user={user}
        />,
        <RoutePrivate
            key="lease-detail"
            path="/leases/:id"
            component={LeasePage}
            isLoggedIn={isLoggedIn}
            permissions={[Permissions.LeaseRecordsAccess]}
            user={user}
        />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/leases/Leases.Routes.tsx